var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGantvestments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 18H14V16.5H3.5V7.5H20.5V12H22V7.5C22 6.67157 21.3284 6 20.5 6H3.5C2.67157 6 2 6.67157 2 7.5V16.5C2 17.3284 2.67157 18 3.5 18Z",
    fill: "#B3C2D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z",
    fill: "#B3C2D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2955 14.1037C16.2464 14.4896 15.7303 15.8404 16.1412 17.1214C16.5528 18.4016 19.53 21.06 19.53 21.06C19.53 21.06 22.5072 18.4016 22.9188 17.1214C23.3297 15.8404 22.8136 14.4896 21.7645 14.1037C21.3162 13.9385 20.8431 13.9768 20.4162 14.1748C20.0808 14.3304 19.7739 14.5847 19.53 14.9164C19.2861 14.5847 18.9792 14.3304 18.6438 14.1748C18.2169 13.9768 17.7438 13.9385 17.2955 14.1037Z",
    fill: "#B3C2D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGantvestments);
export default __webpack_public_path__ + "static/media/Gantvestments.a1835b8cd36ff3e711291c5266e831dc.svg";
export { ForwardRef as ReactComponent };